import { render, staticRenderFns } from "./HeadNavWriter.vue?vue&type=template&id=7528490d&scoped=true"
import script from "./HeadNavWriter.vue?vue&type=script&lang=js"
export * from "./HeadNavWriter.vue?vue&type=script&lang=js"
import style1 from "./HeadNavWriter.vue?vue&type=style&index=1&id=7528490d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7528490d",
  null
  
)

/* custom blocks */
import block0 from "./HeadNavWriter.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports